import { Shot } from '../../types';
import { isPlural, round } from '../../utils';

export const getWildcardText = (
  shots: number[] | Shot[],
  shotNameText: string,
  addText?: string,
) => {
  shots = shots.map((shot) => {
    if (typeof shot === 'number') return round(shot);
    return round(shot.duration);
  });

  if (shots.length === 0) return '';

  if (shots.length === 1)
    return (
      `<b>1 ${shotNameText}</b> that is ` +
      `<b>${shots[0]} second${isPlural(shots[0])}</b> long`
    );

  let shotsLengthText = '';

  if (shots.every((v) => v === shots[0])) {
    shotsLengthText = `${shots[0]} second${isPlural(shots[0])} long</b> each`;
  } else if (shots.length === 2) {
    shotsLengthText = `${shots.join(' & ')} seconds</b> long`;
  } else {
    const shotsTemp = [...shots];
    const last = shotsTemp.pop();
    shotsLengthText = `${shotsTemp.join(', ')} & ${last} seconds</b> long`;
  }

  return (
    `<b>${shots.length} ${shotNameText}s</b> that are ` +
    `<b>${addText ? addText + ' ' : ''}${shotsLengthText}`
  );
};

export const getWildcardTextMaximum = (
  shots: number[] | Shot[],
  shotNameText: string,
  addText?: string,
) => {
  const shotDurations = shots.map((shot) => {
    if (typeof shot === 'number') return round(shot);
    return round(shot.duration);
  });

  const maxDuration = Math.max(...shotDurations);

  return shotDurations.length > 1
    ? `<b>${
        shots.length
      } ${shotNameText}s</b> that are ${addText} <b>${maxDuration} to ${
        maxDuration * 2
      } seconds</b> long`
    : `<b>${
        shots.length
      } ${shotNameText}</b> that is ${addText} <b>${maxDuration} to ${
        maxDuration * 2
      } seconds</b> long`;
};
